module.exports = __webpack_public_path__ + "img/dashcard.old..22d77992.svg";